module.exports = __webpack_public_path__ + "static/media/susan2.2ac98ced.mp3";